// localhost
// export const domain = "https://staging.etipol-express.com/api/v1/";
// export const resource = "https://staging.etipol-express.com/";
// production 
export const domain = "https://website.vpos.club/api/v1/";
export const resource = "https://website.vpos.club/";

// export const domain = "http://127.0.0.1:8000/api/v1/";
// export const resource = "http://127.0.0.1:8000/";
